import React, { HTMLProps } from 'react';
import { tv, VariantProps } from 'tailwind-variants';
import Spinner from './Spinner';

const button = tv({
  base: 'flex flex-row rounded-sm text-gray-03 w-full justify-center gap-1 items-center text-center font-mulish cursor-pointer transition-all duration-200 ease-in-out disabled:opacity-60 disabled:pointer-events-none disabled:select-none',
  variants: {
    shade: {
      primary: 'bg-brand-color-green text-cx-black hover:bg-selected-green',
      secondary: 'bg-brand-color-green text-cx-black hover:bg-selected-green',
      gray: 'bg-gray-04 text-cx-white hover:bg-gray-03',
      blue: 'bg-cx-blue text-cx-black hover:bg-cx-blue/80',
      failed: 'bg-cx-failed text-cx-white hover:bg-cx-failed/80',
      control: 'bg-control text-cx-white hover:bg-control/80',
      empty: 'bg-transparent hover:bg-gray-100/5 focus:ring-gray-500 text-white',
    },
    size: {
      sm: 'px-4 py-2',
      md: 'px-10 py-3',
    },
  },
  defaultVariants: {
    shade: 'primary',
    size: 'md',
  },
});

interface CxButtonProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    VariantProps<typeof button> {
  label: string;
  size?: 'sm' | 'md';
  icon?: React.ReactNode;
  isLoading?: boolean;
  className?: string;
}

export function CxButton({
  label,
  onClick,
  size = 'md',
  icon,
  isLoading,
  className,
  disabled,
  shade,
  type = 'button',
  ...rest
}: CxButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      onClick={onClick}
      className={button({ size, shade, className })}
      disabled={disabled !== undefined ? disabled : isLoading}
    >
      {isLoading ? (
        <Spinner shade="gray" />
      ) : (
        <>
          {icon}
          {label && <p>{label}</p>}
        </>
      )}
    </button>
  );
}
